import { observable } from "micro-observables";

export const startGuide02Requested = observable(false);

export const requestStartGuide02 = (): void => startGuide02Requested.set(true);
export const clearStartGuide02Request = (): void => startGuide02Requested.set(false);
